import tidalTab from './components/tidal-tab.vue';
import tidalTabs from './components/tidal-tabs.vue';

export {
    tidalTab,
    tidalTabs,
};
